import { createUseStyles } from 'react-jss'

const useCheckboxStyles = createUseStyles({
  checkboxWrapper: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    paddingLeft: 30,
    height: 30,
    cursor: 'pointer',
    '-webkit-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    userSelect: 'none',

    '& > input': {
      position: 'absolute',
      opacity: 0,
      cursor: 'pointer',
      height: 0,
      width: 0
    },

    '&.disabled': {
      pointerEvents: 'none',
      opacity: 0.4
    }
  },
  checkmark: {
    position: 'absolute',
    transform: 'translate(25%, 25%)',
    top: 0,
    left: 0,
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid #ddd',
    borderRadius: 4,
    '&:after': {
      display: 'none',
      content: '""',
      position: 'absolute',
      left: 6,
      top: 1,
      width: 5,
      height: 12,
      border: 'solid black',
      borderWidth: '0 3px 3px 0',
      transform: 'rotate(45deg)'
    }
  },
  checkmarkActive: {
    '&:after': {
      display: 'block'
    }
  }
})

export { useCheckboxStyles }
